module.exports = __webpack_public_path__ + "img/picto-messages.0217cf5f.svg";